/* eslint-disable max-lines-per-function */
import { useSuspenseQuery } from '@apollo/client';
import { Antrag, Arbeitsbereich, Mitarbeiter } from '../entities/Arbeitszeit';
import { GET_ANTRAEGE_BY_STANDORT_ID } from './graphql/queries';
import { getDateOrNull } from '@/utils/helperFunctions';
import { Markierung } from '@/gql/graphql';

export function useAntraege(
  standortId: string,
  datum: Date,
): {
  antraege?: Antrag[];
  error?: string;
} {
  const parsedDate = datum.toISOString().slice(0, 10);
  const { data, error } = useSuspenseQuery(GET_ANTRAEGE_BY_STANDORT_ID, {
    variables: { standortId, datum: parsedDate },
    fetchPolicy: 'network-only',
  });

  if (error) {
    return { error: error.message };
  }

  if (data.antraegeByStandortId.__typename !== 'ArbeitszeitAntraege') {
    throw new Error('Unexpected typename');
  }

  const antraege = data.antraegeByStandortId.antraege.map((antrag) => {
    return new Antrag(
      antrag.id,
      antrag.status,
      antrag.arbeitszeitId,
      antrag.offen,
      antrag.bemerkungAntragsteller,
      antrag.bemerkungVorgesetzter,
      getDateOrNull(antrag.datum),
      getDateOrNull(antrag.aenderungsdatum),
      getDateOrNull(antrag.erstellungsdatum),
      new Arbeitsbereich(
        antrag.arbeitsbereich.name,
        antrag.arbeitsbereich.id,
        antrag.arbeitsbereich.markierung as unknown as Markierung,
        [],
      ),
      new Mitarbeiter(
        antrag.mitarbeiter.vorname,
        antrag.mitarbeiter.nachname,
        antrag.mitarbeiter.id,
        false,
        antrag.mitarbeiter.bildUrl,
      ),
      {
        time: getDateOrNull(antrag.beginn),
        isChangeRequested: antrag.arbeitszeitId === null,
      },
      {
        time: getDateOrNull(antrag.ende),
        isChangeRequested: antrag.arbeitszeitId === null,
      },
    );
  });
  return {
    antraege,
  };
}
